import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import SearchViewLayout from './SearchViewLayout';

/** Parse path built by buildSearchAllPath() — same shape as a /search/... URL. */
function parseSearchEmbedFromPath(fullPath) {
  if (!fullPath || typeof fullPath !== 'string') return null;
  const q = fullPath.indexOf('?');
  const pathname = q >= 0 ? fullPath.slice(0, q) : fullPath;
  const search = q >= 0 ? fullPath.slice(q) : '';
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length < 2 || parts[0] !== 'search') return null;
  const objectName = parts[1];
  const slug = parts[2];
  const embedSearchViewName = slug ? decodeURIComponent(slug) : undefined;
  return { embedObjectName: objectName, embedSearchViewName, embedSearch: search };
}

/**
 * Full search view UI in a modal without leaving the current page.
 * Passes route data as props — no nested Router (MemoryRouter is not allowed inside BrowserRouter).
 */
const SearchViewInlineModal = ({ show, onHide, initialPath, title = 'Search' }) => {
  const embed = show && initialPath ? parseSearchEmbedFromPath(initialPath) : null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      fullscreen="lg-down"
      size="xl"
      scrollable
      enforceFocus={false}
      aria-labelledby="search-view-inline-modal-title"
    >
      <Modal.Header closeButton>
        <Modal.Title id="search-view-inline-modal-title">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-0" style={{ minHeight: 'min(70vh, 800px)' }}>
        {embed ? (
          <SearchViewLayout
            key={initialPath}
            embedObjectName={embed.embedObjectName}
            embedSearchViewName={embed.embedSearchViewName}
            embedSearch={embed.embedSearch}
          />
        ) : null}
      </Modal.Body>
      <Modal.Footer className="border-top bg-light justify-content-end">
        <Button type="button" variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SearchViewInlineModal;
